module.exports = __webpack_public_path__ + "static/media/classic.00edaa23.png";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Create/NewResource/images/classic.png
// module id = 1217
// module chunks = 2